import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/api';
import AdminLayout from '../../components/AdminLayout';
import {
  LoginContainer,
  LoginForm,
  Title,
  InputGroup,
  Input,
  Label,
  Button,
  ErrorMessage
} from './LoginStyles';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const data = await login(username, password);
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('isAdminAuthenticated', 'true');
      navigate('/admin/dashboard');
    } catch (err) {
      console.log(err);
      setError('Invalid credentials');
      setTimeout(() => setError(''), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AdminLayout>
      <LoginContainer>
        <LoginForm onSubmit={handleSubmit}>
          <Title>Studio 442 Admin</Title>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          
          <InputGroup delay="0.2s">
            <Input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
            <Label>Username</Label>
          </InputGroup>

          <InputGroup delay="0.4s">
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
            <Label>Password</Label>
          </InputGroup>

          <Button type="submit" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </Button>
        </LoginForm>
      </LoginContainer>
    </AdminLayout>
  );
};

export default Login; 